import { Component, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Clipboard } from '@angular/cdk/clipboard';
import { UtilityService } from '../../core/global/utility.service';
@Component({
  selector: 'app-rich-text-area',
  templateUrl: './rich-text-area.component.html',
  styleUrls: ['./rich-text-area.component.sass']
})
export class RichTextAreaComponent implements OnInit {
  htmlContent = '';
  addUserObj: any = {};
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };
  constructor(private clipboard: Clipboard, private _utility: UtilityService) { }
  async ngAfterViewInit(): Promise<void> {
    var select = await document.getElementsByTagName('i')
    for (let index = 0; index < select.length; index++) {
      if (select[index].classList[0] == 'fa') {
        select[index].classList.remove('fa')
        select[index].classList.add('fas')
      }
    }
   // var el=document.getElementsByClassName('angular-editor-toolbar ng-star-inserted')[0]
    // el.innerHTML+='<div class="angular-editor-toolbar-set" style=" display: inline-block; "><button type="button" title="HTML Code" id="toggleEditorMode-editor1" class="angular-editor-button" (click)="copy()" style=" background-color: #fff; vertical-align: middle; border: 1px solid #ddd;float: right;min-width: 2rem;padding: 0.4rem;"><i class="fas fa-copy"></i></button></div>'
    // el.innerHTML+='<div _ngcontent-ihw-c135 class="angular-editor-toolbar-set"(click)="copy()"> <em class="fas fa-copy fa-fw"></em></div>'




  }
  ngOnInit(): void {
    this.addUserObj.text != ''
  }
  copy() {
    if (!this.addUserObj.text) {
    } else {
      this.clipboard.copy(this.addUserObj.text);
      this._utility.toastSuccess('Copied')

    }
  }
}
